// Mock data for Brandmitra website

export const servicesData = [
  {
    id: 1,
    title: "Creative Design & Communication",
    description: "Brand Guidelines, Communication Strategy, Logo Designs, Creative Designs, Infographics, Video Commercials, VO, E-mailers, Campaign Creatives, ATL & BTL",
    icon: "Palette"
  },
  {
    id: 2,
    title: "Performance Marketing",
    description: "SEM, SMM, Emailer Campaign, Affiliate & Lead Generation Campaign",
    icon: "Target"
  },
  {
    id: 3,
    title: "Web & App Development",
    description: "Web/App Development, Defining UX/UI, Website Maintenance, Custom Software, CMS, CRM",
    icon: "Code"
  },
  {
    id: 4,
    title: "SEO Optimization",
    description: "On Page SEO, Off Page SEO, Link Building, Play store/Appstore Optimization, Keyword Research, SEO Audit, Competition Analysis",
    icon: "TrendingUp"
  },
  {
    id: 5,
    title: "Social Media Management",
    description: "Facebook/Instagram/LinkedIn/Twitter/Pinterest/YouTube Content & Handle Management, Online Reputation Marketing (ORM), Blog Marketing",
    icon: "Share2"
  },
  {
    id: 6,
    title: "E-commerce Sales",
    description: "Develop new sales channels by taking your product to marketplaces like Amazon, Flipkart, Meesho. Build a franchise model to grow exponentially",
    icon: "ShoppingCart"
  }
];

export const portfolioData = [
  {
    id: 1,
    title: "Global Fashion Brand Campaign",
    category: "Full Service",
    description: "Complete digital transformation with 300% increase in online engagement and 150% boost in conversion rates",
    image: "https://images.pexels.com/photos/5685822/pexels-photo-5685822.jpeg",
    metrics: { engagement: "+300%", conversion: "+150%", roi: "450%" }
  },
  {
    id: 2,
    title: "E-commerce Growth Strategy",
    category: "Performance Marketing",
    description: "Scaled marketplace presence across Amazon and Flipkart with data-driven campaigns",
    image: "https://images.pexels.com/photos/7970851/pexels-photo-7970851.jpeg",
    metrics: { sales: "+400%", reach: "2M+", roas: "5.2x" }
  },
  {
    id: 3,
    title: "Tech Startup Branding",
    category: "Creative & Branding",
    description: "End-to-end brand identity development with impactful visual communication strategy",
    image: "https://images.unsplash.com/photo-1753162658596-2ccba5e4246a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHRlYW0lMjBjb2xsYWJvcmF0aW9ufGVufDB8fHx8MTc2OTQ0ODI5NHww&ixlib=rb-4.1.0&q=85",
    metrics: { awareness: "+250%", leads: "+180%", engagement: "+320%" }
  },
  {
    id: 4,
    title: "Healthcare Digital Presence",
    category: "Social Media & SEO",
    description: "Built comprehensive social media strategy with organic growth and SEO optimization",
    image: "https://images.pexels.com/photos/7661185/pexels-photo-7661185.jpeg",
    metrics: { followers: "+500%", organic: "+280%", inquiries: "+220%" }
  },
  {
    id: 5,
    title: "Luxury Real Estate Marketing",
    category: "Full Service",
    description: "Premium digital marketing campaigns targeting high-net-worth individuals",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5fGVufDB8fHx8MTc2OTQ0ODI4OHww&ixlib=rb-4.1.0&q=85",
    metrics: { leads: "+190%", conversions: "+145%", revenue: "+380%" }
  },
  {
    id: 6,
    title: "Food & Beverage Launch",
    category: "Influencer Marketing",
    description: "Strategic influencer partnerships and viral content creation for product launch",
    image: "https://images.unsplash.com/photo-1735639013995-086e648eaa38?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxjcmVhdGl2ZSUyMHRlYW0lMjBjb2xsYWJvcmF0aW9ufGVufDB8fHx8MTc2OTQ0ODI5NHww&ixlib=rb-4.1.0&q=85",
    metrics: { reach: "3.5M+", engagement: "+420%", sales: "+280%" }
  }
];

export const statsData = [
  { label: "Clients Served", value: "150+", icon: "Users" },
  { label: "Successful Campaigns", value: "350+", icon: "Award" },
  { label: "App Designs", value: "50+", icon: "Smartphone" },
  { label: "Years Experience", value: "8+", icon: "Calendar" }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "CEO, TechVision Solutions",
    comment: "Brandmitra transformed our digital presence completely. Their performance marketing strategies delivered exceptional ROI and their team is incredibly professional.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5fGVufDB8fHx8MTc2OTQ0ODI4OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    name: "Priya Sharma",
    position: "Marketing Director, FashionHub",
    comment: "Working with Brandmitra has been a game-changer. They understand our vision and consistently deliver creative solutions that exceed expectations.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5fGVufDB8fHx8MTc2OTQ0ODI4OHww&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    name: "Amit Patel",
    position: "Founder, GrowthFirst",
    comment: "Their data-driven approach to performance marketing helped us scale our business 4x. Highly recommend Brandmitra for serious growth!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYWdlbmN5fGVufDB8fHx8MTc2OTQ0ODI4OXww&ixlib=rb-4.1.0&q=85"
  }
];

export const clientLogos = [
  "Amazon", "Flipkart", "Google", "Facebook", "Microsoft", 
  "Adobe", "Shopify", "Salesforce", "HubSpot", "Mailchimp"
];
